import { _loginwithpass, _sendOTP, _VerifyOTP } from "../constants/api";
import { toast } from 'react-toastify';

export const sendOtp = async (phoneNumber) => {
  try {
    const response = await fetch(_sendOTP, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'clientid': 'e0ce9cb8-430e-4148-b562-b8833cc9fa0b',
      },
      body: JSON.stringify({ phoneNumber }),
    });
    const responseJSON = await response.json();
    return responseJSON;
  } catch (error) {
    console.log('Error occurred in the send OTP API ==> ', error);
    toast.error("Too many requests, please try again later.")
    throw error;
  }
};

export const verifyOtp = async (phoneNumber, otp,navigate) => {
  try {
    const response = await fetch(_VerifyOTP, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'clientid': 'e0ce9cb8-430e-4148-b562-b8833cc9fa0b',
      },
      body: JSON.stringify({ phoneNumber, otp }),
    });
    const responseJSON = await response.json();

    if (responseJSON.userData.isClient) {
     
      localStorage.setItem('user', JSON.stringify(responseJSON.userData));
      toast.success('Login successful!');
      
      navigate('/notification-template'); 
    } else {
      toast.error('You are not authorized to access this application.');
      navigate('/');
    }

    return responseJSON;
  } catch (error) {
    console.log('Error occurred in the verify OTP API ==> ', error);
    throw error; 
  }
};

export const loginWithPassword = async (email, password, navigate) => {
  try {
    const response = await fetch(_loginwithpass, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'clientid': 'e0ce9cb8-430e-4148-b562-b8833cc9fa0b',
      },
      body: JSON.stringify({ email, password }),
    });
    const responseJSON = await response.json();

    if (responseJSON.isClient) {
     
      localStorage.setItem('user', JSON.stringify(responseJSON));
      toast.success('Login successful!');
      
      navigate('/notification-template'); 
    } else {
      toast.error('You are not authorized to access this application.');
      navigate('/');
    }

    return responseJSON;
  } catch (error) {
    console.log('Error occurred in the login with password API ==> ', error);
    toast.error('Login failed. Please try again.');
    throw error;  
  }
};
